import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validFastMovingSlowMovingTypes } from "../../../Appconstants";
import { fastMovingSlowMovingItems } from "../../../redux/actions/API/dashboardActions";
import InventoryExtra from "./InventoryExtra";
import { useEffect } from "react";

interface IFastSlowMovingItemsProps {
  fastMovingSlowMovingItems: Function;
  fastMovingSlowMovingItemsState: any;
  fastMovingSlowMovingItemsLoading: boolean;
  companyId: any;
}

const FastSlowMovingItems: React.FC<IFastSlowMovingItemsProps> = ({
  companyId,
  fastMovingSlowMovingItems,
  fastMovingSlowMovingItemsState,
  fastMovingSlowMovingItemsLoading,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const typeIndexParam = Number(searchParams.get("typeIndex"));
  const hasValidTypeIndex =
    Number.isInteger(typeIndexParam) &&
    typeIndexParam >= 0 &&
    typeIndexParam < validFastMovingSlowMovingTypes.length;
  const selectedTypeIndex = hasValidTypeIndex ? typeIndexParam : 0;

  const orderedTypeIndexes = hasValidTypeIndex
    ? [
        selectedTypeIndex,
        ...validFastMovingSlowMovingTypes
          .map((_: string, index: number) => index)
          .filter((index: number) => index !== selectedTypeIndex),
      ]
    : validFastMovingSlowMovingTypes.map((_: string, index: number) => index);

  const dropdownOptions = orderedTypeIndexes.map((index: number) => ({
    label: validFastMovingSlowMovingTypes[index],
    value: index,
  }));

  useEffect(() => {
    const resolvedType =
      validFastMovingSlowMovingTypes[selectedTypeIndex] ||
      validFastMovingSlowMovingTypes[0];

    fastMovingSlowMovingItems({
      companyId: Number(companyId),
      type: resolvedType,
    });
  }, [companyId, selectedTypeIndex, fastMovingSlowMovingItems]);

  const handleDropdownChange = (value: string | number) => {
    navigate(`/fastSlowMovingItems?typeIndex=${Number(value)}`);
  };

  return (
    <InventoryExtra
      breadcrumbTitle="Fast/Slow Moving"
      dropdownOptions={dropdownOptions}
      loading={fastMovingSlowMovingItemsLoading}
      selectedValue={selectedTypeIndex}
      handleDropdownChange={handleDropdownChange}
      tableData={fastMovingSlowMovingItemsState}
    />
  );
};

const mapStateToProps = (state: any) => ({
  companyId: state.api.login?.data?.companyId,
  fastMovingSlowMovingItemsState:
    state.api.fastMovingSlowMovingItems?.fastMovingSlowMovingItems,
  fastMovingSlowMovingItemsLoading:
    state.api.fastMovingSlowMovingItems?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
  fastMovingSlowMovingItems: (payload: any) =>
    dispatch(fastMovingSlowMovingItems(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FastSlowMovingItems);
